import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

EDC.Games.SeasonsOrdering.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.SeasonsOrdering, 48]);
  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.gameData = EDC.Games.SeasonsOrdering.GameData;
  this.difficulty = 1;
  this.iteration = 1;
  this.correctAnswer = null;
  this.choices = [];
  this.startingSeason = [];
  this.windowSprite1 = null;
};

EDC.Games.SeasonsOrdering.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.SeasonsOrdering.Scenes.Main.prototype.constructor = EDC.Games.SeasonsOrdering.Scenes.Main;

const SO = EDC.Games.SeasonsOrdering.Scenes.Main.prototype;

SO.create = function () {
  this.initialize();

  this.loadIteration();
  this.createTemplateUI();

  this.createBasicUI();
};

SO.createTemplateUI = function () {
  this.add.sprite(915, 110, 'title').setScale(1.1);
  this.windowSprite1 = this.add
    .sprite(460, 480, 'window')
    .setScale(0.95)
    .setDepth(1);
  this.add.sprite(1370, 480, 'window').setScale(0.95);
  this.add.sprite(920, 650, 'arrow');
  this.add.sprite(1370, 470, 'question-mark');
  this.add.sprite(915, 420, 'question').setScale(0.95);
};

SO.loadIteration = function () {
  this.addStartingSeason();
  this.addChoices();
};

SO.addStartingSeason = function () {
  const currentSeason = this.gameConfig.sets[this.difficulty].startingSeason;
  const startingSeason = this.add.sprite(460, 480, currentSeason);
  this.generateCorrectAnswer(currentSeason);
  const dogHint = this.add.sprite(1815, 740, `dog-${this.correctAnswer}`);
  this.startingSeason.push(startingSeason);
  this.startingSeason.push(dogHint);
};

SO.generateCorrectAnswer = function (season) {
  if (season === 'winter') {
    this.correctAnswer = 'spring';
  } else if (season === 'spring') {
    this.correctAnswer = 'summer';
  } else if (season === 'summer') {
    this.correctAnswer = 'autumn';
  } else if (season === 'autumn') {
    this.correctAnswer = 'winter';
  }
};

SO.addChoices = function () {
  for (let i = 0; i < 4; i++) {
    const { season, seasonX, seasonY } = this.getSeasonsPos(i);
    const choiceContainer = this.add.container(seasonX, seasonY);
    const choice = this.add.sprite(0, 0, season).setScale(0.58);
    choiceContainer.add(choice);
    choiceContainer.init_X = seasonX;
    choiceContainer.seasonText = season;
    choiceContainer.setSize(568, 456);
    choiceContainer.setInteractive();
    const markAnim = new AnswerMark(this, choiceContainer).setScale(0.25);
    choiceContainer.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(choiceContainer);
    choiceContainer.on('pointerup', this.checkAnswer.bind(this, choiceContainer), this);
    this.choices.push(choiceContainer);
  }
};

SO.getSeasonsPos = function (i) {
  // let season;
  // let seasonX;
  // let seasonY;
  const seasons = {
    0: 'summer',
    1: 'autumn',
    2: 'winter',
    3: 'spring',
  };
  const seasonY = 900;
  const seasonX = 390 + i * 350;
  const season = seasons[i];
  return { season, seasonX, seasonY };
};

SO.checkAnswer = function (answer) {
  if (answer.seasonText === this.correctAnswer) {
    this.playCorrect();
    this.choices.map((x) => {
      x.disableInteractive();
      return true;
    });
    answer.getData('markAnim').showMark(true, () => {});
    this.time.delayedCall(2000, this.nextIteration, [], this);
  } else {
    this.playWrong();
    answer.first.setTint(0xff0000);
    answer.disableInteractive();
    answer.getData('markAnim').showMark(false, () => {});
    this.shakeAnimation(answer);
  }
};

SO.nextIteration = function () {
  if (this.iteration >= this.gameConfig.iterations) {
    this.windowSprite1.setDepth(0);
    this.showSummary();
  } else {
    if (this.difficulty !== 3) {
      this.difficulty = this.difficulty + 1;
    }
    this.iteration = this.iteration + 1;
    this.correctAnswer = null;
    this.choices.map((x) => {
      x.destroy();
      return true;
    });
    this.choices = [];
    this.startingSeason.map((x) => {
      x.destroy();
      return true;
    });
    this.startingSeason = [];
    this.loadIteration();
  }
};

SO.shakeAnimation = function (answer) {
  answer.x += 10;
  this.tweens.add({
    targets: answer,
    x: answer.x - 10,
    duration: 30,
    ease: 'Linear',
    repeat: 3,
    yoyo: true,
    onComplete: this.returnToInitPos,
    onCompleteParams: [answer],
  });
};

SO.returnToInitPos = function (tween, targets, answer) {
  answer.x = answer.init_X;
};

export default EDC.Games.SeasonsOrdering.Scenes.Main;
